import { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import swal from "sweetalert";
import useApiServices from "../../utils/useApiServices";
import { AGGREGATOR_SAVE, GET_ALL_PRIVILAGES } from "../../utils/constant";
import MasterMerchantForm from "./MasterMerchantForm";

const CreateMasterMerchant = ({ show, onHide, onSuccess }) => {
  const api = useApiServices();
  const [privilegesData, setPrivilegesData] = useState([]);
  const [selectedPrivileges, setSelectedPrivileges] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.apiCallFnforGet(GET_ALL_PRIVILAGES).then((res) => {
      setPrivilegesData(res?.data || []);
    });
  }, []);

  const handleSubmit = async (payload) => {
    setLoading(true);
    const res = await api.apiCallFnforPost(AGGREGATOR_SAVE, payload);
    setLoading(false);

    if (res?.statusCode === 200) {
      swal("Success", "Aggregator Created Successfully", "success");
      onHide();
      onSuccess();
    } else {
      swal("Error", res?.message || "Failed", "error");
    }
  };

  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      placement="end"
      style={{ width: "90vw" }}
    >
      <div
        className="d-flex justify-content-start align-items-center mt-3"
        style={{ marginLeft: "28px" }}
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <h5 class="offcanvas-title fs-2 text-dark fw-bold" id="offcanvasLabel">
          Create Master Merchant
        </h5>
      </div>
      <Offcanvas.Body>
        <MasterMerchantForm
          mode="create"
          privilegesData={privilegesData}
          selectedPrivileges={selectedPrivileges}
          setSelectedPrivileges={setSelectedPrivileges}
          onSubmit={handleSubmit}
          loading={loading}
        />
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default CreateMasterMerchant;
